<template src="@/templates/dashboard/reportsAndStatistics.html"></template>

<script>
    import ClientDashboardCollection from "@/collections/clientDashboardCollection";
    import ByImagesChart from '@/components/dashboard/charts/ByImages'
    import JobsChart from '@/components/dashboard/charts/Jobs'
    import moment from 'moment'

    export default {
        name: "ReportsAndStatistics",
		props: ['page', 'isTitle', 'chartHeightOffset'],
        components: {
           	JobsChart, ByImagesChart
        },
        data() {
            return {
                title: "",
	            showTitle: true,
	            heightOffset: 0,
	            clientDashboardCollection: new ClientDashboardCollection,
				boards: [],
                showSpinner: true,
                isResize: false,
	            chartHeight: 0,
	            offset: 100
            }
        },
        created() {
	        this.setViewHeight();
	        if (this.isTitle === false) this.showTitle = this.isTitle;
        	else this.showTitle = true;
        	
            if (this.chartHeightOffset > 0) this.heightOffset = this.chartHeightOffset;
        	else this.heightOffset = 0;
        	
            this.getBoards();
            this.title = this.page.title;
        },
        mounted() {
            let resizeId;
            let thisComponent = this;
            window.addEventListener('resize', function () {
                clearTimeout(resizeId);
                resizeId = setTimeout(thisComponent.doneResizing, 500);
            });
        },
        methods: {
            doneResizing() {
                this.isResize = true;

                if (this.$browserDetect.isSafari) {
                    setTimeout(function () {
                        window.location.reload();
                    }, 500);
                    return;
                }

                this.$router.go(0);
            },
	        getBoards() {
		        let url = this.$localApiURL + this.clientDashboardCollection.getRoute("fetch") +
			        "?token=" + localStorage.getItem('jwt') +
			        "&client_dashboard_page_id=" + this.page.client_dashboard_page_id;

		        this.$http.get(url).then((response) => {
			        if (response.data !== null && response.data !== {}) {
				        this.boards = response.data;
				        this.showSpinner = false;
			        }
		        })
				.catch((error) => {
					console.error(error);
				});
            },
	        setViewHeight() {
		        this.chartHeight = (window.innerHeight - (this.heightOffset > 0 ? this.heightOffset : this.offset));
	        }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/ReportsAndStatistics.vue